module.exports = __webpack_public_path__ + "img/8.b57949e7.jpg";